import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "frisbuy-summary-widget__ai-wrapper" }


export default /*#__PURE__*/_defineComponent({
  __name: 'AIBlock',
  props: {
    text: {},
    count: {},
    anchorText: {}
  },
  emits: ["swipeToMarket"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(props.text), 1),
    _createTextVNode("   "),
    _createElementVNode("div", {
      class: "frisbuy-summary-widget__ai-wrapper--link",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('swipeToMarket')))
    }, _toDisplayString(props.count) + " " + _toDisplayString(props.anchorText), 1)
  ]))
}
}

})